import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import {
    MAT_DIALOG_DATA, MatDialog,
    MatDialogActions,
    MatDialogClose,
    MatDialogContent,
    MatDialogTitle,
} from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { MatRippleModule } from '@angular/material/core';
import { User } from '../../../shared/interfaces/user';
import { MatButtonModule } from '@angular/material/button';
import { CURRENT_USER } from '../../../shared/tokens/current-user';
import { Router } from '@angular/router';
import { CloseDialogComponent } from '../../components/close-dialog/close-dialog.component';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-password-pin-dialog',
    standalone: true,
    imports: [CommonModule, MatDialogContent, MatDialogTitle, MatRippleModule, MatDialogClose, MatDialogActions, MatButtonModule, CloseDialogComponent],
    templateUrl: './password-pin-dialog.component.html',
    styleUrl: './password-pin-dialog.component.scss',
})
export class PasswordPinDialogComponent {
    public digits = [1, 2, 3, 4, 5, 6, 7, 8, 9, '', 0, ''];

    public error: boolean | undefined;

    public pin = '';

    public constructor(
        @Inject(MAT_DIALOG_DATA) public readonly data: { user?: User } | undefined,
        @Inject(CURRENT_USER) private readonly user: User,
        private readonly router: Router,
        private readonly dialog: MatDialog,
    ) {
        //
    }

    public onPinConfirm(): void {
        const password = this.user?.settings?.bf2_password_pin;

        if (password !== this.pin) {
            this.error = true;
            return;
        }

        this.dialog.closeAll();
        this.router.navigate(['admin', this.user.store.id, 'sales']);
    }

    public onPinEnter(digit: number | string): void {
        this.error = false;
        this.pin += digit;
        if (this.pin.length >= 5) {
            this.pin = this.pin.substr(0, 4);
            return;
        }
    }

    public onPinErase(): void {
        this.error = false;
        this.pin = this.pin.slice(0, this.pin.length - 1);
    }
}
